import { WorkloadConfig } from '../types';

interface JsonPreviewProps {
  config: WorkloadConfig;
  onClose: () => void;
  onSave?: () => void;
}

export function JsonPreview({ config, onClose, onSave }: JsonPreviewProps) {
  const jsonString = JSON.stringify(config, null, 2);

  const handleCopy = () => {
    navigator.clipboard.writeText(jsonString);
    // TODO: Show success toast notification instead of alert
    console.log('Copied to clipboard!');
  };

  return (
    <div className="json-preview-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Configuration Preview</h3>
          <button onClick={onClose} className="close-btn">
            ×
          </button>
        </div>

        <div className="modal-body">
          <pre className="json-display">{jsonString}</pre>
        </div>

        <div className="modal-footer">
          <button onClick={handleCopy} className="btn-secondary">
            Copy to Clipboard
          </button>
          {onSave && (
            <button onClick={onSave} className="btn-primary">
              Save to Git
            </button>
          )}
          <button onClick={onClose} className="btn-secondary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
